import { useEffect } from "react";
import { Box, Button, Container, Tooltip, Typography } from "@material-ui/core";

import dayjs from "dayjs";
import { NavLink as RouterLink } from "react-router-dom";
import { XSquare as XSquareIcon } from "react-feather";
import Title from "../../components/common/title";
import Add from "./Add";
import CustomTable from "../../components/common/CustomTable";
import CustomLinearProgress from "../../components/common/CustomLinearProgress";
import AddOut from "./AddOut";
import useAccount from "../../hooks/useAccount";
import ConfirmationDialog from "../../components/common/ConfirmationDialog";

const voucherTypes = [
  { label: "Chi khác", id: 1, value: 1, key: 1, dataValue: "C-0" },
  { label: "Trả lương", id: 2, value: 2, key: 2, dataValue: "C-1" },
  { label: "Trả lãi", id: 3, value: 3, key: 3, dataValue: "C-2" },
  { label: "Chi tiêu dùng", id: 4, value: 4, key: 4, dataValue: "C-3" },
  { label: "Chi trả quỹ", id: 5, value: 5, key: 5, dataValue: "C-4" },
  { label: "Tạm ứng", id: 6, value: 6, key: 6, dataValue: "C-5" },
  { label: "Hoa hồng", id: 7, value: 7, key: 7, dataValue: "C-6" },
  { label: "Chi vé hoặc văn phòng", id: 7, value: 8, key: 8, dataValue: "C-7" },
  { label: "Chi mua xe", id: 9, value: 9, key: 9, dataValue: "C-8" },
  { label: "Chi Dọn xe - Hồ sơ", id: 10, value: 10, key: 10, dataValue: "C-9" },
  { label: "Chi Tiền Nhà", id: 11, value: 11, key: 11, dataValue: "C-10" },
  { label: "Chi mượn tiền", id: 12, value: 12, key: 12, dataValue: "C-11" },
  { label: "Thu khác", id: 13, value: 13, key: 13, dataValue: "T-0" },
  { label: "Thu trả quỹ", id: 14, value: 14, key: 14, dataValue: "T-1" },
  { label: "Thu tiền nợ", id: 15, value: 15, key: 15, dataValue: "T-2" },
  { label: "Thu tiền ứng", id: 16, value: 16, key: 16, dataValue: "T-3" },
  { label: "Thu tiền phạt", id: 17, value: 17, key: 17, dataValue: "T-4" },
  { label: "Thu hoa hồng", id: 18, value: 18, key: 18, dataValue: "T-5" },
  {
    label: "Thu tiền vé hoặc văn phòng",
    id: 19,
    value: 19,
    key: 19,
    dataValue: "T-6"
  },
  { label: "Bán xe", id: 20, value: 20, key: 20, dataValue: "T-7" },
  { label: "Thu hồ sơ", id: 21, value: 21, key: 21, dataValue: "T-8" },
  { label: "Thu lãi khác", id: 22, value: 22, key: 22, dataValue: "T-9" }
];
const ActivityList = () => {
  const {
    listCashFlow,
    useGetListCashFlow,
    loading,
    handleClose,
    handleOutClose,
    open,
    openOut,
    handleOpen,
    handleOpenOut,
    openModalDelete,
    deleteId,
    remove,
    deleteModalContent,
    handleCloseModalDelete,
    handleOpenModalDelete
  } = useAccount();

  useEffect(() => {
    useGetListCashFlow();
  }, []);

  const options = {
    filterType: "checkbox",
    selectableRows: false,
    downloadOptions: {
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true
      }
    }
  };
  const handleDelete = (event, title, id) => {
    event.preventDefault();
    handleOpenModalDelete(title, id);
  };
  const handleExportExcel = () => {
    const icon = document.querySelector("[data-testid='CloudDownloadIcon']");
    const parentIcon = icon.parentNode;
    if (parentIcon) {
      parentIcon.click();
    }
  };

  const columns = [
    {
      name: "status",
      label: "",
      options: {
        display: false,
        filter: false
      }
    },
    {
      name: "id",
      label: "#",
      options: {
        customBodyRender: (value, tableMeta) => {
          const { rowIndex } = tableMeta;
          const status = tableMeta.rowData[0];
          const className = status === "cancel" ? "line-through" : "";
          return <Box className={className}>{rowIndex + 1}</Box>;
        }
      }
    },
    {
      name: "createdAt",
      label: "Ngày Thu/Chi",
      options: {
        customBodyRender: (value, tableMeta) => {
          const status = tableMeta.rowData[0];
          const className = status === "cancel" ? "line-through" : "";
          return (
            <Box className={className}>{dayjs(value).format("DD/MM/YYYY")}</Box>
          );
        }
      }
    },
    {
      name: "partnerName",
      label: "Khách hàng",
      options: {
        customBodyRender: (value, tableMeta) => {
          const status = tableMeta.rowData[0];
          const className = status === "cancel" ? "line-through" : "";
          return <Box className={className}>{value}</Box>;
        }
      }
    },
    {
      name: "type",
      label: "",
      options: {
        display: false,
        filter: false
      }
    },
    {
      name: "voucherType",
      label: "Loại phiếu",
      options: {
        customBodyRender: (value, tableMeta) => {
          const status = tableMeta.rowData[0];
          const className = status === "cancel" ? "line-through" : "";
          // eslint-disable-next-line no-shadow
          const item = voucherTypes.find(item => item.dataValue === value);
          return <Box className={className}>{item?.label}</Box>;
        }
      }
    },
    {
      name: "reason",
      label: "Lý do",
      options: {
        customBodyRender: (value, tableMeta) => {
          const status = tableMeta.rowData[0];
          const className = status === "cancel" ? "line-through" : "";
          return <Box className={className}>{value}</Box>;
        }
      }
    },
    {
      name: "amount",
      label: "Số tiền",
      options: {
        customBodyRender: (value, tableMeta) => {
          const type = tableMeta.rowData[4];
          const prefix = type === "in" ? "+" : "-";
          const status = tableMeta.rowData[0];
          const className = status === "cancel" ? "line-through" : "";
          return (
            <Box
              className={`${className} font-bold ${
                type === "in" ? "text-blue-800" : "text-red-800"
              }`}
            >
              {prefix}
              {`${value?.toLocaleString("en-US") || 0} VNĐ`}
            </Box>
          );
        }
      }
    },
    {
      name: "userName",
      label: "Nhân viên",
      options: {
        customBodyRender: (value, tableMeta) => {
          const status = tableMeta.rowData[0];
          const className = status === "cancel" ? "line-through" : "";
          return <Box className={className}>{value}</Box>;
        }
      }
    },
    {
      name: "id",
      label: "Chức năng",
      hasFilter: false,
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { textAlign: "center", width: "100px" }
        }),
        customBodyRender: (value, tableMeta) => {
          const cashFlow = listCashFlow.find(p => p.id === value);
          const { type } = cashFlow;
          const status = tableMeta.rowData[0];
          if (status === "inactive") {
            return null;
          }
          return (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <RouterLink
                className="mr-1 rounded-full bg-warning text-action-color p-2"
                onClick={event =>
                  handleDelete(
                    event,
                    `${type === "in" ? "Hủy phiếu thu" : "Hủy phiếu chi"}`,
                    cashFlow.id
                  )
                }
                to="#"
              >
                <Tooltip
                  title={`${type === "in" ? "Hủy phiếu thu" : "Hủy phiếu chi"}`}
                  placement="top"
                >
                  <XSquareIcon size={16} />
                </Tooltip>
              </RouterLink>
            </Box>
          );
        }
      }
    }
  ];

  const pageTitle = "Quản lý hoạt động thu chi";
  return (
    <>
      <Title id={pageTitle} />
      <Add open={open} handleClose={handleClose} />
      <AddOut handleClose={handleOutClose} open={openOut} />
      <ConfirmationDialog
        open={openModalDelete}
        handleClose={handleCloseModalDelete}
        onSubmit={() => remove(deleteId)}
        title="Hủy"
        confirmTitle={`Bạn có chắc chắn ${deleteModalContent.toLowerCase()} này không?`}
        content={deleteModalContent}
      />
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <Box>
            <Button
              color="primary"
              className="customButton"
              variant="contained"
              onClick={handleOpen}
              size="small"
              sx={{
                marginRight: 1
              }}
            >
              Thêm Phiếu Thu
            </Button>

            <Button
              color="primary"
              className="customButton"
              variant="contained"
              onClick={handleOpenOut}
              size="small"
            >
              Thêm Phiếu Chi
            </Button>

            <Button
              color="secondary"
              sx={{
                ml: 1
              }}
              size="small"
              className="customButton"
              variant="contained"
              onClick={handleExportExcel}
            >
              Xuất excel
            </Button>
          </Box>
          {/* <Button */}
          {/*  color="primary" */}
          {/*  className="customButton" */}
          {/*  variant="contained" */}
          {/*  onClick={handleOpen2} */}
          {/* > */}
          {/*  Form */}
          {/* </Button> */}
          <Box sx={{ pt: 3 }}>
            {loading ? (
              <CustomLinearProgress />
            ) : (
              <CustomTable
                title={<Typography variant="h2">{pageTitle}</Typography>}
                data={listCashFlow}
                options={options}
                columns={columns}
                id="quan-ly-hoat-dong-thu-chi"
              />
            )}
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default ActivityList;
